import React from 'react';
import useWidth from '../../hooks/useWidth'


function TableRanking({data, segment}) {
  const { width } = useWidth();  

  return (
    <section className='TableRanking'>
        <div className='TableRanking__content'>
          <div className='TableRanking__content--img'>
            <img src={`/assets/images/cup_winner_${segment}.png`} alt="cup_winner" className='cup_winner' />
            <span className={`TableRanking__content--title ${segment}_bold`}>Conoce <br/>los 70 ganadores de</span>
            <span className={`TableRanking__content--subtitle ${segment}_bold`}>Para tooodo <br/> lo que quieres</span>
           
            {width > 992 &&
            <>
             <br/>
             <span className={`TableRanking__content--contact`}>
                Si ganas, Tuya S.A. te contactará.<br/>
                <strong>Recuerda:</strong> nunca te pediremos dinero ni datos sensibles.
              </span>   
            </>}
              
          </div>  
          <div className='TableRanking__content--table'>
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>{width > 992 ? 'Posición en el ranking' : 'Ranking'}</th>
                    <th>Ganador</th>
                    <th>Premio</th>
                  </tr>
                </thead>
              </table>

              <div className="table-scroll">
                <table>
                  <tbody>
                  {data.map((item) => (
                    <tr key={item.id}>
                      <td className="head_hight ranking_color">{item.id}</td>
                      <td className={`head_hight ${segment}_bold`}>{item.name}</td>
                      <td className="head_hight">{item.price}</td>
                    </tr>
                  ))}
                </tbody>
                </table>
              </div>
            </div>
          </div>

          {width <= 992 &&
            <>
             <span className={`TableRanking__content--contact`}>
                Si ganas, Tuya S.A. te contactará.<br/>
                <strong>Recuerda:</strong> nunca te pediremos dinero ni datos sensibles.
              </span>   
            </>}
        </div>
    </section>

  );
}

export default TableRanking
